import { TFunction } from '@lyearn/i18n';
import { getQuestionConfig } from '@/modules/corporate/components/picklist';
import { formatDimensionHTML } from '@/modules/report/views/ReportEditor/utils/formatters/dimension';
import { DifficultyEnum, Maybe, QuestionApplicableOnEnum, QuestionTypeEnum } from '@/types/schema';

class QuestionEntity {
  static questionTextLabel(questionText: Maybe<string> | undefined) {
    return formatDimensionHTML(questionText ?? '');
  }

  static questionTypeLabel(
    questionType: QuestionTypeEnum,
    t: TFunction,
    applicableOn = QuestionApplicableOnEnum.Quiz,
  ) {
    const config = getQuestionConfig(applicableOn)[questionType];
    return config ? t(config.labelKey) : '';
  }

  static questionTypeIcon(
    questionType: QuestionTypeEnum,
    applicableOn = QuestionApplicableOnEnum.Quiz,
  ) {
    const config = getQuestionConfig(applicableOn)[questionType];
    return config ? config.Icon : null;
  }

  static difficulty(difficulty: Maybe<DifficultyEnum> | undefined) {
    return difficulty ?? DifficultyEnum.Na;
  }

  static isActive(isActive: Maybe<boolean> | undefined) {
    return isActive ?? true;
  }
}

export default QuestionEntity;
